module.exports = __webpack_public_path__ + "static/team-08a2c5e1b74462cdc286405fd2acb992.jpg";